// Copyright (C) 2020-2023 Berkadia Commercial Mortgage, LLC - All Rights Reserved
import API from '../../../apis/API'
import emailList from '../../../apis/emailList'
import APIInterceptor from '../../../apis/APIInterceptors'


const uploadEmailListCSV = (payload) => {
    try {
        return APIInterceptor(emailList.uploadEmailListCSV, payload)
    } catch (ex) {
        console.log(ex)
        throw ex
    }
    // catch (error) {
    //     if (APIInterceptor.isCancel(error)) {
    //     } else {
    //         throw error
    //     }
    // }
}

const createNewEmailListCSV = (payload) => {
    try {
        return APIInterceptor(emailList.createNewEmailListCSV, payload)
    } catch (ex) {
        console.log(ex)
        throw ex
    }
}

const downloadEmailListCSV = (elist_id) => {
    try {
        return APIInterceptor(emailList.downloadEmailListCSV + `?elist_id=${elist_id}`, null, 'get')
    } catch (ex) {
        console.log(ex)
        throw ex
    }
}

const getEmailLists = (payload) => {
    try {
        // return API.post(emailList.getEmailLists, payload)
        // console.log(process.env.NODE_ENV)
        return APIInterceptor(emailList.getEmailLists, payload)
    } catch (ex) {
        console.log(ex)
        throw ex
    }
}

const getEmailList = (payload) => {
    try {
        // return API.post(emailList.getEmailList, payload)
        return APIInterceptor(emailList.getEmailList, payload)
    } catch (ex) {
        console.log(ex)
        throw ex
    }
}

const fetchEmailListContacts = (payload) => {
    try {
        //return API.post(emailList.getEmailListContacts, payload)
        return APIInterceptor(emailList.getEmailListDetail, payload)
    } catch (ex) {
        console.log(ex)
        throw ex
    }
}

const getSavedSummary = payload => {
    try {
        return APIInterceptor(emailList.getSavedSummary, payload)
    } catch (ex) {
        console.log(ex)
        throw ex
    }
}

const getPostMailingContatsCount = payload => {
    try {
        return APIInterceptor(emailList.getPostMailingContatsCount, payload)
    } catch (ex) {
        console.log(ex)
        throw ex
    }
}

const saveEmailList = payload => {
    try {
        // return API.post(emailList.savePublishEmailList, payload)
        return APIInterceptor(emailList.saveEmailList, payload)
    } catch (ex) {
        console.log(ex)
        throw ex
    }
}

const publishEmailList = payload => {
    try {
        // return API.post(emailList.savePublishEmailList, payload)
        return APIInterceptor(emailList.savePublishEmailList, payload)
    } catch (e) {
        console.log('error at publishEmailList', e)

        return null
    }
}

const getEmailListofContactById = payload => {
    try {
        // return API.post(emailList.getEmaiListOfContactById, payload)
        return APIInterceptor(emailList.getEmaiListOfContactById, payload)
    } catch (ex) {
        console.log(ex)
        throw ex
    }
}

const getContacts = payload => {
    try {
        // return API.post(emailList.getContacts, payload)
        return APIInterceptor(emailList.getContacts, payload)
    } catch (ex) {
        console.log(ex)
        throw ex
    }
}

const updateEmailListForAddDelete = payload => {
    try {
        // return API.post(emailList.updateEmailListForAddDelete, payload)
        return APIInterceptor(emailList.updateEmailListForAddDelete, payload)
    } catch (ex) {
        console.log(ex)
        throw ex
    }
}

const deleteEmailList = payload => {
    try {
        return APIInterceptor(emailList.deleteEmailList, payload)
    } catch (ex) {
        console.log(ex)
        throw ex
    }
}

const cloneEmailList = (payload) => {
    try {
        return APIInterceptor(emailList.cloneEmailList, payload)
    } catch (ex) {
        console.log(ex)
        throw ex
    }
}

const renameEmailList = (payload) => {
    try {
        return APIInterceptor(emailList.renameEmailList, payload)
    } catch (ex) {
        console.log(ex)
        throw ex
    }
}

const deleteContacts = (payload) => {
    try {
        return APIInterceptor(emailList.deleteContacts, payload)
    } catch (ex) {
        console.log(ex)
        throw ex
    }
}

const addContactsToEmailList = payload => {
    try {
        return APIInterceptor(emailList.addContactsToEmailList, payload)
    } catch (ex) {
        console.log(ex)
        throw ex
    }
}

const downloadcsv = payload => {
    try {
        // const header = { 'Content-Type': 'application/x-www-form-urlencoded' }
        return APIInterceptor(emailList.downloadcsv, payload)
    } catch (ex) {
        console.log(ex)
        throw ex
    }
}

export {
    getEmailList, getEmailLists, fetchEmailListContacts, saveEmailList, publishEmailList,
    getEmailListofContactById, getContacts, updateEmailListForAddDelete, uploadEmailListCSV,
    createNewEmailListCSV, downloadEmailListCSV, getSavedSummary, getPostMailingContatsCount, deleteEmailList, cloneEmailList,
    renameEmailList, deleteContacts, addContactsToEmailList, downloadcsv
}